import React, {useEffect, useRef, useState} from "react";
import HeaderBreadCrumb from "../../../BreadCrumb/Breadcrumb";
import {useLocation, useNavigate} from "react-router-dom";
import LoadingScreen from "../../../../containers/LoadingScreen/LoadingScreen";
import Aux from "../../../../hoc/Auxiliary"
import {findDataCollectionById} from "../../../../api/dataCollection/dataCollection-service";
import Dashboards from "./Dashboards/Dashboards";
import {Fieldset} from "primereact/fieldset";
import classes from "./DataVisualisation.module.css";
import keycloak from "../../../../keycloak";
import {isAuthorized} from "../../../../api/authorization/authorization-service";
import ErrorServer from "../../../ErrorServer/ErrorServer";
import QueriesDetailsConfigurations from "./QueriesConfigurations/DetailedQueries/QueriesDetailsConfigurations";
import QueriesOverviewConfigurations from "./QueriesConfigurations/OverviewQueries/QueriesOverviewConfigurations";
import {updateProperty} from "../../../../api/utils/conditions-utils";
import {loadState, removeFromSessionStorage} from "../../../../api/State/manage-state-storage-service";
import {onServerCallError} from "../../../../api/utils/errors";
import {FileUpload} from "primereact/fileupload";
import {getAllQueryFileNamesPerDataCollection, saveQuery} from "../../../../api/file/upload-service";
import {showError} from "../../../../api/notification/ToastManager";

const DataVisualisation = () => {
    const {state} = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [dcName, setDcName] = useState(null)
    const [groups, setGroups] = useState(null)
    const [crumbs, setCrumbs] = useState([])
    const [dashboardSectionTitle, setDashboardSectionTitle] = useState("")
    const [dashboardSectionCollapsed, setDashboardSectionCollapsed] = useState(true)
    const [categories, setCategories] = useState([]);
    const [dataCollection, setDataCollection] = useState({});
    const [fileName, setFileName] = useState();
    const [topicsDetails, setTopicsDetails] = useState([]);

    const fileUploadRef = useRef(null);
    useEffect(() => {
        setIsLoading(true);
        try {
            const group = keycloak.idTokenParsed.fullPathGroup.flatMap(e => e.split("/"));
            const dc = loadState(state, "dataCollection");
            if (dc?.name && dc?.id && group !== null) {
                setDcName(dc?.name);
                setGroups(group)
                setCrumbs(["Data Collections", "Dashboards"]);
                findDataCollectionById(dc?.id).then(res => {
                    if (res.categories) {
                        setDataCollection(res)
                        setCategories(res.categories);
                    } else {
                        setIsError(true)
                    }
                }).catch(_ => {
                    onServerCallError("Data collection not find", "Could not find a data collection with name '" + dc?.name + "'", goBack)
                })
                setIsLoading(false);
            } else {
                goBack()
            }
            const isAuth = isAuthorized("AR08") === true;
            setDashboardSectionTitle(updateProperty(isAuth, "Manage Dashboards", "Data Collection Dashboards"))
            setDashboardSectionCollapsed(isAuth)
        } catch (e) {
            onServerCallError("Error loading page", "An error occurs while displaying Dashboards page", goBack)
        }
    }, [])

    const getBase64 = file => {
        return new Promise(resolve => {
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsText(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    }

    useEffect(() => {
        if (Object.keys(dataCollection).length !== 0) {
            getAllQueryFileNamesPerDataCollection(dataCollection?.id).then(res => {
                if (res !== null) {
                    res.forEach(r => {
                        r.isChecked = false;
                    });
                    setTopicsDetails(res)
                }
            });
        }
    }, [dataCollection])
    const handleFileInputChange = (e) => {
        let file = e.files[0];
        let ext = file.name.split(".");

        if (ext[ext.length - 1].toLowerCase() !== "ttl") {

            showError("Uploaded file must be TURTLE")
            fileUploadRef.current.clear();
        } else {

            setFileName(file['name']);
            getBase64(file).then((res) => {
                try {
                    saveQuery({
                            fileName: file["name"],
                            contentFile: res,
                            topicQueryInfo: {
                                dataCollection: dataCollection,
                                queryLocation: "",
                                queryName: "",
                                topic: {},
                                category: {},
                                queryContent: "",
                                createdBy: keycloak.idTokenParsed.name,
                                createdIn: new Date(),
                            }
                        }
                    ).then(() => {
                        getAllQueryFileNamesPerDataCollection(dataCollection.id).then(r => {
                            if (r !== null) {
                                r.forEach(res => {
                                    res.isChecked = false;
                                });
                                setTopicsDetails(r)
                            }
                        })
                        fileUploadRef.current.clear();
                    })
                } catch (err) {

                    fileUploadRef.current.clear();
                }
            });
        }


    };
    const goBack = () => {
        removeFromSessionStorage("dataCollection");
        navigate('/data_collections');
    }

    const headerInfo = (
        <Aux>
            <h3 className={classes.title}>{dcName}</h3>
        </Aux>
    )

    const error = isError
        ? (<ErrorServer/>)
        : (<Aux>
            <HeaderBreadCrumb items={crumbs}/>
            <br/>
            {headerInfo}
            <br/>
            {updateProperty(isAuthorized("AR01"),
                <Aux>
                    <Fieldset legend="Manage queries to persist detailed data" toggleable collapsed={true}>
                        <div style={{display: "flex"}}>
                            {updateProperty(isAuthorized("AR01"),
                                <div className={"col-3 p-0 m-0"}><p className={classes.text}>⚠️ Topic without query will
                                    not be persisted.</p></div>, null)}
                            <div className={"col-9 p-0 m-0"}>
                                <div className={"flex flex-row-reverse"}>
                                    <FileUpload
                                        ref={fileUploadRef}
                                        name="demo[]"
                                        accept=".ttl"
                                        className={classes.uploadBtn}
                                        maxFileSize={100000000000}
                                        mode="basic"
                                        style={{paddingBottom: "10px"}}
                                        chooseLabel={" Add a detailed query"}
                                        onSelect={handleFileInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <QueriesDetailsConfigurations topicsDetails={topicsDetails} setTopicsDetails={setTopicsDetails}
                                                      categories={categories} dataCollection={dataCollection}/>
                    </Fieldset>
                    <br/>
                    <Fieldset legend="Manage queries to persist overview data" toggleable collapsed={true}>
                        <QueriesOverviewConfigurations dataCollectionId={dataCollection.id}
                                                       dataCollectionName={dataCollection.name}/>
                    </Fieldset>
                    <br/>
                </Aux>
                , null)}
            <Fieldset legend={dashboardSectionTitle} toggleable={dashboardSectionCollapsed}
                      collapsed={dashboardSectionCollapsed}>
                {updateProperty(
                    isAuthorized("AR08"),
                    <div>
                        <p className={classes.text}>⚠️ Dashboard tag name in kibana must be equal to the data collection
                            name.
                            Otherwise,
                            dashboard will not be attached to the data collection. </p>
                        <p className={classes.text}>⚠️ Dashboard will be shared with all participants.
                        </p>
                    </div>, null
                )}
                <Dashboards setIsLoading={setIsLoading} setIsError={setIsError} dcName={dcName} groups={groups}/>
            </Fieldset>
        </Aux>);

    return updateProperty(isLoading, <LoadingScreen/>, error);
}

export default DataVisualisation;
